"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const pinia_1 = require("pinia");
const App_vue_1 = __importDefault(require("./App.vue"));
const vue_router_1 = __importDefault(require("vue-router"));
const routes_1 = __importDefault(require("./routes"));
const plugins_1 = __importDefault(require("./components/plugins"));
const utils_1 = require("./utils");
const ant_design_vue_1 = __importDefault(require("ant-design-vue"));
const zhuge_1 = require("./utils/zhuge");
(0, zhuge_1.zhuge)();
(0, utils_1.login)(() => {
    const router = vue_router_1.default.createRouter({
        history: vue_router_1.default.createWebHistory(),
        routes: routes_1.default,
    });
    const app = (0, vue_1.createApp)(App_vue_1.default);
    app.use((0, pinia_1.createPinia)());
    app.use(router);
    app.use(ant_design_vue_1.default);
    app.use(plugins_1.default);
    app.mount("#app");
});
